namespace exjs {
    export var version = '0.5.1';
}